
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { fundmanagerapi } from "../../ApiNames";

export const fetchdatasuccess = (data: any) => ({
    type: 'fetch_data_success',
    payload: data
})
export const fetchcheckdatasuccess = (checkdata: any) => ({
    type: 'fetch_check_data_success',
    payload: checkdata
})
export const fetchdata = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid: uid };
            const apiname = fundmanagerapi.fmdonationslist;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdatasuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
}
export const fetchcheckdata = (donationid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { donation: donationid, q:4 };
            const apiname = fundmanagerapi.donationslist;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchcheckdatasuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
}
